import DOMPurify from "dompurify";

export class Sanitizer {

    public constructor() {
        DOMPurify.addHook("afterSanitizeAttributes", (node) => {
            if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
                node.setAttribute("rel", "noopener noreferrer");
            }
        });
    }

    public sanitizeHTML(html: string): string {
        return DOMPurify.sanitize(html,{ ADD_ATTR: ["target"] });
    }
}